export default __webpack_public_path__ + "static/media/close-white.a5f26976.svg";